/** Symbole fuer eigene Listen (F-33) - eine feste Auswahl, gespeichert wird der Schluessel. */
import {
  BookOpen, Dumbbell, Film, Gift, Heart, House, Lightbulb, List, Luggage, Music, Plane, ShoppingCart, Star, Utensils,
  type LucideIcon,
} from 'lucide-react';

export const LISTEN_SYMBOLE: Record<string, { label: string; icon: LucideIcon }> = {
  liste: { label: 'Liste', icon: List },
  einkauf: { label: 'Einkauf', icon: ShoppingCart },
  idee: { label: 'Idee', icon: Lightbulb },
  koffer: { label: 'Koffer', icon: Luggage },
  geschenk: { label: 'Geschenk', icon: Gift },
  film: { label: 'Film', icon: Film },
  essen: { label: 'Essen', icon: Utensils },
  buch: { label: 'Buch', icon: BookOpen },
  musik: { label: 'Musik', icon: Music },
  reise: { label: 'Reise', icon: Plane },
  herz: { label: 'Herz', icon: Heart },
  sport: { label: 'Sport', icon: Dumbbell },
  zuhause: { label: 'Zuhause', icon: House },
  stern: { label: 'Stern', icon: Star },
};

export const symbolVon = (key: string): LucideIcon => LISTEN_SYMBOLE[key]?.icon ?? List;
